import { useMatches } from "react-router-dom";

import { RouteHandle } from "router/routes/types";

export const useScreenTestId = (): string | undefined => {
  const matches = useMatches();
  const deepestWithTestId = [...matches].reverse().find(m => (m.handle as RouteHandle)?.testId);
  const testId = (deepestWithTestId?.handle as RouteHandle)?.testId;
  return testId ? `screen__${testId}` : undefined;
};
